import { FilterItemType } from '@/pages/dashboard/types/dashboard';
import { RANGE_DAILY, RANGE_WEEKLY, RANGE_MONTHLY, RANGE_DATE, CONTRAST_DAILY, CONTRAST_DAITE, SINGLE_DAILY, CONTRAST_DAILY2 } from '@/pages/dashboard/components/NewFilter/FilterBase/_config';
import moment from 'moment';
export const SELECTOR_KEY_MAP: any = {
  'lang': 'lang_list',
  'region': 'area_list',
  'channel': 'channel_list',
  'zone': 'zone_list',
  'system': 'os_list',
  'competitor': 'competitor_list',
  'networkType': 'network_list',
  'mediaChannel': 'channel_list',
  'appVersion': 'app_version_list',
  'memory': 'memory_list',
  'storeChannel': 'store_channel_list',
  'category': 'category_list',
  'stage': 'stage_list',
  'churn_level': 'churn_level_list',
  'bundle': 'bundle_list',
  'metrics': 'metrics_list'
};

// 筛选器保存专用，筛选器保存不包含ua和竞品页面的特殊筛选器
export const SELECTOR_SAVE_KEY_CODE: any = {
  'lang': 'lang_code',
  'region': 'country_code',
  'channel': 'channel_id',
  'zone': 'zone_code',
  'system': 'os_id',
  // 漏斗定制化筛选器
  'appVersion': 'app_id',
  'networkType': 'network_id',
  'memory': 'memory_id',
  'storeChannel': 'store_channel_id',
  'mediaChannel': 'channel_id',
  'stage': 'stage_id',
  'churn_level': 'churn_level',
  'bundle': 'bundle_id',
  'source': 'value',
  'competitor': 'unified_id',
  'metrics': 'metric',
};

// 筛选器保存专用，筛选器保存不包含ua和竞品页面的特殊筛选器，注意region不是region_list
export const SELECTOR_SAVE_KEY_MAP: any = {
  'lang': 'lang_list',
  'region': 'country_list',
  'channel': 'channel_list',
  'zone': 'zone_list',
  'system': 'os_list',
  // 漏斗定制化筛选器
  'appVersion': 'app_version_list',
  'networkType': 'network_list',
  'memory': 'memory_list',
  'storeChannel': 'store_channel_list',
  'stage': 'stage_list',
  'mediaChannel': 'channel_list',
  'churn_level': 'churn_level_list',
  'bundle': 'bundle_list',
  'source': 'source_list',
  'competitor': 'competitor_list',
  'metrics': 'metrics_list'
};

export const FUNNEL_SELECTOR_KEY_MAP: any = {
  // 漏斗定制化筛选器
  'app_version': 'appVersion',
  'network_type': 'networkType',
  'store_channel': 'storeChannel',
  'churn_level': 'churn_level',
  'source': 'source',
  'competitor': 'competitor',
  'category': 'category',
  'product': 'product',
};

export const FILTER_VALUE_TYPE_DATE = [RANGE_DAILY, RANGE_WEEKLY, RANGE_MONTHLY];



export const DEFAULT_FILTER_CONFIG: FilterItemType[] = [
  {
    "name_cn": "区服",
    "name_en": "Zone",
    "key": "zone",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "渠道",
    "name_en": "Channel",
    "key": "channel",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  }
];

// pc console框架，默认筛选器按region/country、platform、language，zone/channel这两个筛选器不要
export const PC_CONSOLE_DEFAULT_FILTER_CONFIG: FilterItemType[] = [
  {
    "name_cn": "区服",
    "name_en": "Zone",
    "key": "zone",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "渠道",
    "name_en": "Channel",
    "key": "channel",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ],
    "view_type": "group"
  },
  {
    "name_cn": "语言",
    "name_en": "Language",
    "key": "lang",
    "visible": 0,
    "default": ["255"]
  }
];

// 休闲游戏框架前端默认筛选器
export const CASUAL_DEFAULT_FILTER_CONFIG: FilterItemType[] = [
  {
    "name_cn": "区服",
    "name_en": "Zone",
    "key": "zone",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "渠道",
    "name_en": "Channel",
    "key": "channel",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  { 
    "name_cn": "语言",
    "name_en": "Language",
    "key": "version",
    "visible": 0,
    "default": ["255"]
  },
  {
    "name_cn": "买量渠道",
    "name_en": "Media Channel",
    "key": "ua_network",
    "visible": 1,
    "default": ["255"]
  },
  {
    "name_cn": "版本",
    "name_en": "Version",
    "key": "version",
    "visible": 1,
    "default": ["255"]
  },
  {
    "name_cn": "用户类型",
    "name_en": "User Type",
    "key": "user_type",
    "visible": 0,
    "default": ["255"]
  },
  {
    "name_cn": "活动",
    "name_en": "Campaign",
    "key": "campaign",
    "visible": 0,
    "default": ["255"]
  },
  {
    "name_cn": "网络类型",
    "name_en": "Network Type",
    "key": "network_type",
    "visible": 0,
    "default": ["255"]
  }
];


export const FILTER_WIDTH = {
  default: 208,
  [RANGE_DAILY]: 281,
  [RANGE_WEEKLY]: 281,
  [RANGE_MONTHLY]: 281,
  [CONTRAST_DAILY]: 301,
  [RANGE_DATE]: 306,
  [CONTRAST_DAITE]: 420,
  rangePrefix: 114
} as any;

// 最近一周、一月、一天相关
export const getSingleDailyValue = () => moment();
export const getContrastDailyValue = () => moment().subtract(7, 'days');
export const getRangeDateValue = () => [moment().subtract(1, 'days'), moment().subtract(1, 'days')];

export const getRangeWeekValue = () => 
  // [moment().weekday(-7), moment().weekday(-1)]
  [  moment().subtract(1, 'week').startOf('isoWeek'),moment().subtract(1, 'week').endOf('isoWeek')]
;
export const getRangeMonthValue = () => [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
// export const RANGE_DAY_MONTH_VALUE = {
//   day: ['1', '30'],
//   month: ['1', '6']
// }
export const DURATION_TYPE_VALUE: any = {
  [SINGLE_DAILY]: {
    type: 'date',
    name: 'Today',
    nameCN: '当天',
    value: getSingleDailyValue()
  },
  // 实际上没用到CONTRAST_DAILY
  [CONTRAST_DAILY]: {
    type: 'date',
    name: 'Last 7 Days',
    nameCN: '7天前',
    value: getContrastDailyValue()
  },
  [RANGE_DAILY]: {
    type: 'date',
    name: 'Yesterday',
    nameCN: '昨天',
    value: getRangeDateValue()
  },
  [RANGE_WEEKLY]: {
    type: 'week',
    name: 'Last Week',
    nameCN: '上周',
    value: getRangeWeekValue()
  },
  [RANGE_MONTHLY]: {
    type: 'month',
    name: 'Last Month',
    nameCN: '上月',
    value: getRangeMonthValue()
  },
  // [RANGE_DAY_MONTH]: {
  //   date: {
  //     type: 'date',
  //     value: RANGE_DAY_MONTH_VALUE.month
  //   },
  //   month: {
  //     type: 'month',
  //     value: RANGE_DAY_MONTH_VALUE.day
  //   }
  // },
  // 下面为多粒度的相关内容，对应key为rangeTime、rangeDate、StaticsDate等
  date: {
    type: 'date',
    name: 'Yesterday',
    nameCN: '昨天',
    value: getRangeDateValue()
  },
  week: {
    type: 'week',
    name: 'Last Week',
    nameCN: '上周',
    value: getRangeWeekValue(),
  },
  month: {
    type: 'month',
    name: 'Last Month',
    nameCN: '上月',
    value: getRangeMonthValue(),
  }
};

export const RANGE_DATE_KEY: { [key: string]: string; } = {
  [RANGE_DAILY]: 'Day',
  [RANGE_WEEKLY]: 'Week',
  [RANGE_MONTHLY]: 'Month',
  [SINGLE_DAILY]: 'Day',
  [CONTRAST_DAILY]: 'Day',
  [CONTRAST_DAILY2]: 'Day',
};

export const LATEST_DATE_KEY_ARR = ['lasteDateDate', 'lasteDateWeek', 'lasteDateMonth'];